$('#zipCode').on('keyup', function () {
  var zip = $('#zipCode').val();
  zip = zip.replace('-', '');
  if (zip.length == 8) {
    $('#load-spin').show(200);
      $.ajax({
        type: 'GET',
        url: 'https://viacep.com.br/ws/' + zip + '/json/',
        success: function (response) {
          $('#district').val(response.bairro);
          $('#street').val(response.logradouro);
          $('#state').val($('#state option:contains(' + response.uf + ')').val()).trigger('change');
          $('#state_id').val($('#state').val());
          $('#city_id').val(response.ibge);
        }
      }).done(function () {
        $('#load-spin').hide(200);
        $('input[name="address[number]"]').focus();
      });
  }
});

function selectCity(city) {
  setTimeout(function () {
    $('#city').val(city).trigger('change');
  }, 100);
}

$('select[name="address[state_id]"]').on('change', function () {
  get_cities_by_state($(this).val());
});

$(window).ready(function () {
  var stateId = $("select[name='address[state_id]']").val();
  get_cities_by_state(stateId);
});

function get_cities_by_state(state_id) {
  var token = $('meta[name="csrf-token"]').attr('content');
  $.post("/ajax/cities", {_token: token, state_id: state_id}).done(function (data) {
    fill_cities_select(data);
  });
}

function fill_cities_select(data) {
  var $field = $('select[name="address[city_id]"]');
  $('select[name="address[city_id]"] option').remove();

  $.each(JSON.parse(data), function (id, name) {
    var option = new Option(name, id);
    $field.append(option);
  });

  var city_id = $('input[name="city_id"]').val();
  if (city_id !== undefined && $.isNumeric(city_id)) {
    $('select[name="address[city_id]"]').val(city_id).trigger('change');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/search/cep.js